module.exports = __webpack_public_path__ + "img/NochLächelnSie.57b04231.jpg";